import { EN, LANGUAGE, ZH_CN } from "../config/hosts/index";
import en from "./locales/en.json";
import zh from "./locales/zh.json";
import en_adgm from "./locales/en_adgm.json";
import zh_adgm from "./locales/zh_adgm.json";
import zh_saas from "./locales/zh_saas.json";
import en_saas from "./locales/en_saas.json";
import { isClient } from "./common";
import { systemDetection } from "./systemDetection";
import { BRAND } from "@aspen/model";

const chekLanguage: () => string = () => {
  if (isClient) {
    localStorage.setItem(LANGUAGE, EN);
    if (location.pathname.includes(EN)) {
      localStorage.setItem(LANGUAGE, EN);
    }
    if (location.pathname.includes(ZH_CN)) {
      localStorage.setItem(LANGUAGE, ZH_CN);
    }
  }
  return !isClient ? EN : (localStorage.getItem(LANGUAGE) ?? "");
};

const i18nUtil = {
  locales: [EN, ZH_CN],
  locale: chekLanguage(),
  updateLocale: (language: string) => {
    i18nUtil.locale = language;
  },
  t: () => {
    let res;
    const system = systemDetection();
    switch (i18nUtil.locale) {
      case ZH_CN:
        res = Object.assign(system === BRAND ? zh : zh_adgm, zh_saas);
        break;
      case EN:
        res = Object.assign(system === BRAND ? en : en_adgm, en_saas);
        break;
      default:
        res = Object.assign(system === BRAND ? zh : zh_adgm, zh_saas);
    }
    return res;
  },
  formatMessage: (id: { id: string }, option?: object) => {
    const _idd: string = Object.values(id)[0] ?? "";
    let _str = i18nUtil.t()[_idd];
    let _resStr = _str;
    if (option) {
      Object.keys(option).map(() => {
        const keyReg = new RegExp(/\{.*?\}/g);
        const res = _str?.match(keyReg);
        if (res?.length > 0) {
          res.map((r: string) => {
            if (r && _str.includes(r)) {
              const _key = r.replace("{", "").replace("}", "");
              _resStr = _resStr?.replaceAll && _resStr.replaceAll(r, option[_key]);
            }
          });
        }
      });
    }
    return _resStr;
  }
};

export { i18nUtil };
